import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

function getDayjs(date: string | Date) {
	return typeof date === 'string' ? dayjs.utc(date, 'YYYY-MM-DD') : dayjs.utc(date);
}

export { dayjs, getDayjs };
